import { useMap } from '@vis.gl/react-google-maps'
import { useEffect, useMemo, useState } from 'react'
import { GoogleMapsOverlay } from '@deck.gl/google-maps'

export const DeckGlOverlay = ({ layers }) => {
    const [loaded, setLoaded] = useState(false)
    const deck = useMemo(() => new GoogleMapsOverlay({ interleaved: true, onLoad: () => setLoaded(true), onError: (err) => {
        if (err) {
            window.location.reload()
        }
    } }), [])

    const map = useMap()

    useEffect(() => {
        deck.setMap(map)

        return () => deck.finalize()
    }, [deck, map])
    
    useEffect(() => {   
        if (!loaded) return
        deck.setProps({ layers, useDevicePixels: 1 })
    }, [deck, layers, loaded])
    

    return null
}
